export default "__VITE_ASSET__DeJ7DwA8__"